import { triggerMergeCartOnLogin } from 'src/scripts/utils/cart/cart-apis';
import '../../../styles/templates/customers/account.scss';
import '../../../styles/templates/customers/order-details.scss';
import './account/runShopByColor';
import { InitOrderHistory } from '../_shared/ui-components/Account/OrderHistory';
import { InitAccountMenu } from '../_shared/ui-components/Account/AccountMenu';

(async function () {
  const OTP_LOGIN_RETURN_URL_KEY = 'otp-login-return-url';

  function isAllowedReferrer(referrer: string | null): boolean {
    if (!referrer) {
      return false;
    }
    try {
      const url = new URL(referrer);
      const hostname = url.hostname.toLowerCase();
      if (hostname.endsWith('.aloyoga.com') || hostname.includes('www.alo')) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  const redirectToPostLoginDestination = async (storageKey: string) => {
    const returnUrl = window.sessionStorage.getItem(storageKey);
    if (!returnUrl) {
      return false;
    }

    await triggerMergeCartOnLogin();
    window.sessionStorage.removeItem(storageKey);
    if (returnUrl === '/account') return true;

    const redirectUrl = returnUrl.includes(window.location.origin)
      ? returnUrl
      : window.location.origin + (returnUrl[0] === '/' ? returnUrl : '/' + returnUrl); // XXS protection

    window.location.href = redirectUrl;
    return true;
  };

  if (await redirectToPostLoginDestination(OTP_LOGIN_RETURN_URL_KEY)) {
    return;
  }

  if (!isAllowedReferrer(document.referrer)) {
    if (await redirectToPostLoginDestination('social-login-return-url')) {
      return;
    }
  }
})();

window.addEventListener('DOMContentLoaded', () => {
  InitOrderHistory();
  InitAccountMenu();
});
